import React from "react"


export interface ISwitchProps {
    checked: boolean;
    label?: React.ReactNode;
    onChange: (checked: boolean) => void;
    name?: string;
    error?: string;
}

export const Switch: React.FC<ISwitchProps> = ({ label, onChange, checked }) => {
    return (
        <div className="d-flex align-items-center">
            {label && <label className="me-2 form-label">{label}</label>}
            <label className="switch">
                <input type="checkbox" checked={checked} />
                <span className={`slider slider-rounded`}
                    onClick={() => onChange(!checked)}>
                </span>
            </label>
        </div>
    );
}